import reducer from "./reducer";
export { default as conceptsSetSettings } from "./components/index";
export { default as conceptsSetSettingsReducerName } from "./constants";
export default reducer;
